<template>
  <div class="hornet-head" :style="{width:'calc(100% - '+width+'px)'}">
    <div class="head-child">
      <div @click="change" class="icon-wrap">
        <i class="el-icon-s-fold change-icon" :class="openMenu ? 'colume-icon' : ''"></i>
      </div>
      <div class="path">
        {{currentMenu.parent_name}} / <span class="current">{{currentMenu.name}}</span>
      </div>
    </div>
    <div class="head-child">
      <div class="icon-wrap">
        <el-avatar icon="ios-person" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" />
        <div class="text">
          <span>{{user.nickname}}</span>
          <span v-show="roleName">（{{roleName}}）</span>
          <!-- <i class="el-icon-arrow-down"></i> -->
        </div>
        <div class="child-actions">
          <!-- <Actions @handleOpen="handleOpen" /> -->
        </div>
      </div>
      <div class="line"></div>
      <div @click="handleLoginOut" class="icon-wrap">
        <div>退出登录</div>&nbsp;
        <span class="iconfont icon-tuichu"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { loginOutStorage, getStorageAdminUser, getStorageUserRoleName } from '@/utils/store'
import { mapActions, mapState } from 'vuex'
// import Actions from './components/actions'
  export default {
    // components: {
    //   Actions,
    // },
    props: {
      width: {
        type: Number,
        default: () => 0
      },
      openMenu: {
        type: Boolean,
        default: () => true
      }
    },
    data() {
      return {
        user: getStorageAdminUser(),
        roleName: getStorageUserRoleName(),
        userMinModal: false
      }
    },
    computed: {
      ...mapState({
        currentMenu: state => state.app.currentMenu
      })
    },
    methods: {
      ...mapActions('app',[
        'loginOut'
      ]),
      handleOpen() {
        this.$emit('handleOpen')
      },
      change() {
        this.$emit('change')
      },
      handleLoginOut() {
        this.$confirm(`确认退出重新登录吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.replace({path: '/login'});
          this.$nextTick(() => {
            loginOutStorage()
            this.loginOut()
            location.reload();
          })
        })
      },
      handleMouseOver() {
        this.userMinModal = true
      },
      handleMouseOut() {
        this.userMinModal = false
      }
    },
    
  }
</script>

<style lang="scss">
.hornet-head {
  height: 64px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  position: fixed;
  top: 0;
  right: 0;
  transition: all .2s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 10;
  .icon-wrap {
    height: 100%;
    padding: 0 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;
    .change-icon {
      font-size: 22px;
      transition: all .2s;
      transform: rotate(90deg);
    }
    .colume-icon {
      transform: rotate(0deg);
    }
    .child-actions {
      display: none;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      transform: translateY(100%);
    }
    &:hover {
      background: #f8f8f9;
      .child-actions {
        display: block;
      }
    }
  }
  .head-child {
    height: 100%;
    display: flex;
    align-items: center;
    user-select: none;
    .path {
      margin-left: 10px;
      color: #999;
      .current {
        color: #333;
      }
    }
    .text {
      margin-left: 10px;
      font-size: 14px;
    }
    .iconfont {
      font-size: 20px;
      color: #333;
      margin-left: 5px;
      margin-top: 2px;
    }
    .line {
      height: 30px;
      width: 1px;
      background: #f3f3f3;
    }
  }
}
</style>